// src/components/Style/GameModeSelectStyle.js
// ルートBox
export const GAMEMODE_ROOT_BOX_SX = {
    m: 1,
    p: 4,
};

// 画面全体（Paper）
export const GAMEMODE_SCREEN_PAPER_SX = {
    m: 1,
    p: 1,
    bgcolor: '#f5f5dc',
    borderRadius: '1px',
    height: '250px',
    width: '250px',
    position: 'absolute',
    top: '20px',
    left: '40px',
};

// タイトル「ゲームモードせんたく」
export const GAMEMODE_TITLE_TEXT_SX = {
    fontFamily: 'DotGothic16',
    fontSize: '24px',
    color: '#000000',
};

// 選択欄（ラジオボタン枠）の Box
export const GAMEMODE_SELECT_BOX_SX = {
    fontFamily: 'DotGothic16',
    color: '#000000',
    border: '3px solid #696969',
    borderRadius: '5px',
    padding: '0 5px',
    top: '45px',
    left: '102px',
    position: 'absolute',
};

// メッセージ欄の枠（Grid の sx）
export const GAMEMODE_MESSAGE_GRID_SX = {
    border: '3px solid #696969',
    borderRadius: '5px',
    padding: '0 5px',
    top: '200px',
    left: '5px',
    position: 'absolute',
    width: '96%',
    height: '23%',
};

// メッセージ内テキスト
export const GAMEMODE_MESSAGE_TEXT_SX = {
    fontFamily: 'DotGothic16',
    fontSize: '12px',
    color: '#000000',
};
